import { Select } from '@wkda/styleguide';
import cx from 'classnames';
import { Field } from 'react-final-form';
import { useEffect } from 'react';
import { useCarleadCreationFormStore } from '../../Form/CarleadCreationFormStore';
import shallow from 'zustand/shallow';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectField = _ref => {
  let {
    input,
    props
  } = _ref;
  const {
    placeholder,
    className,
    mktSelector,
    onChange,
    ...rest
  } = props;
  const [value, setLabel] = useCarleadCreationFormStore(state => [state.values[input.name], state.setLabel], shallow);
  useEffect(() => {
    if (typeof value !== 'undefined') {
      const label = props.options.find(o => o.value === value)?.label;
      setLabel(input.name, label);
    }
  }, [input.name, props.options, setLabel, value]);
  return /*#__PURE__*/_jsx(Select, {
    ...input,
    ...rest,
    placeholderOption: placeholder,
    className: cx('carlead-creation-field__control carlead-creation-field--select', className),
    onChange: e => {
      input.onChange(e);
      onChange?.(e);
    },
    mktSelector: mktSelector?.value
  });
};
export function selectFieldRenderer(props) {
  return /*#__PURE__*/_jsx(Field, {
    name: props.name,
    props: props,
    render: SelectField
  });
}